import SafeIcon from '../common/SafeIcon';
import './location-map.css';

const mapUrl = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249.3636450214468!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2e9500106f0f3%3A0x2a72a669444de185!2sK%20%26%20Sons%20Guest%20house!5e0!3m2!1sen!2ssg!4v1792694982192!5m2!1sen!2ssg';

export default function LocationMap({ className = '' }) {
  return (
    <div className={`contact-map location-map ${className}`}>
      <iframe
        title="K and son’s Guest House location on Google Maps"
        src={mapUrl}
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
      <a className="button button-outline" href="https://maps.app.goo.gl/rvLZmrNdX4RyBcLr7" target="_blank" rel="noopener noreferrer">
        Get Directions <SafeIcon name="ArrowUpRight" />
      </a>
    </div>
  );
}